import React from "react";
import styles from './Success.module.scss';
import Logo from "../logo/Logo";
import Button from "../button/Button";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const Success = ({ 
  message,
  showLogin = true
}) => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <Logo />
      <h1 className={styles.title}>{message}</h1>
      <svg className={styles.animate} xmlns="http://www.w3.org/2000/svg" width="199" height="199" viewBox="0 0 199 199" fill="none">
        <circle cx="99.5" cy="99.5" r="99.5" fill="#CACAFF"/>
        <circle cx="99.5" cy="98.5" r="86.5" fill="#E1E1FF"/>
        <circle cx="99" cy="98" r="77" fill="#EAEBFF"/>
        <path className={styles.line} d="M69.3775 107.12L92.6725 126.871L138.201 76.1299" stroke="#171898" strokeWidth="17" strokeLinecap="round"/>
      </svg>
      {showLogin && <Button
        label="Proceed to Login"
        onClick={() => {
          navigate('/login');
        }}
      />}
    </div>
  );
};

Success.propTypes = {
  message: PropTypes.string.isRequired,
  showLogin: PropTypes.bool
}

export default Success;